import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import { useRecoilValue } from 'recoil'
import breadcrumbPathsUtils from '@/shared/BreadcrumbPaths/breadcrumbPaths.utils'
import BreadcrumbPaths from '@/shared/BreadcrumbPaths'
import parameterGroupsAtom from '../../parameterGroups.atom'
import { memo } from 'react'

interface IProps {
  groupId: IParameterGroup['id']
  isToggleButtonVisible?: boolean
}

const ParameterGroupBreadcrumbsPath = ({ groupId, isToggleButtonVisible = false }: IProps) => {
  const groups = useRecoilValue(parameterGroupsAtom).items
  const paths = breadcrumbPathsUtils.getPathsGroup(groupId, groups, (group) => group.name)

  return <BreadcrumbPaths paths={paths} isToggleButtonVisible={isToggleButtonVisible} />
}

export default memo(ParameterGroupBreadcrumbsPath)
